import React, { useReducer, createContext } from 'react';
import PropTypes from 'prop-types';

const initialState = {
  user: null,
  balanceData: {},
  hasPlanZero: null,
  roamingData: {},
  showChatbot: false,
  showNavbar: true,
  hasKushkiCards: false,
  smsPremiumServices: null,
  showMenuMobile: false,
};

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'setUser':
      return { ...state, user: payload };
    case 'setBalanceData':
      return { ...state, balanceData: payload };
    case 'setHasPlanZero':
      return { ...state, hasPlanZero: payload };
    case 'setRoamingData':
      return { ...state, roamingData: payload };
    case 'setShowChatbot':
      return { ...state, showChatbot: payload };
    case 'setShowNavbar':
      return { ...state, showNavbar: payload };
    case 'setHasKushkiCards':
      return { ...state, hasKushkiCards: payload };
    case 'setSmsPremiumServices':
      return { ...state, smsPremiumServices: payload };
    case 'setShowMenuMobile':
      return { ...state, showMenuMobile: payload };
    default:
      return { ...state };
  }
};

const AppContext = createContext(initialState);

const AppProvider = ({ children, initial }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const contextValue = {
    ...state,
    ...initial,
    setUser: user => dispatch({ type: 'setUser', payload: user }),
    setBalanceData: data => dispatch({ type: 'setBalanceData', payload: data }),
    setHasPlanZero: data => dispatch({ type: 'setHasPlanZero', payload: data }),
    setRoamingData: data => dispatch({ type: 'setRoamingData', payload: data }),
    setShowChatbot: data => dispatch({ type: 'setShowChatbot', payload: data }),
    setShowNavbar: data => dispatch({ type: 'setShowNavbar', payload: data }),
    setHasKushkiCards: data =>
      dispatch({ type: 'setHasKushkiCards', payload: data }),
    setSmsPremiumServices: data =>
      dispatch({ type: 'setSmsPremiumServices', payload: data }),
    setShowMenuMobile: data =>
      dispatch({ type: 'setShowMenuMobile', payload: data }),
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initial: PropTypes.shape({}),
};

AppProvider.defaultProps = { initial: {} };

export { AppContext as default, AppProvider };
